import React, { useEffect, useState, useRef } from 'react';
import * as XLSX from 'xlsx';
import { MwButton, MwInputText, MwSelector, MwSpinnerButton, NoDataFound } from '../ui';
import { useTranslation } from 'react-i18next';
import { useCurrent, useFetch } from '../../hooks';
import SalesReportsList from './SalesReportsList';
import MwCardWrapper from '../ui/MwCardWrapper';
import { printableDiv } from '../../utils/global';
import { FaRegFileExcel, FaPrint, FaFilePdf } from "react-icons/fa";
import handleConvertToPDF from '../../utils/handleConvertToPDF';

const SalesReports = () => {
  const divPrintRef = useRef();
  const [t, i18n] = useTranslation('global');
  const { currentLangId } = useCurrent();
  const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();

  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1).toLocaleDateString('en-CA');
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).toLocaleDateString('en-CA');
  
  const [formStates, setFormStates] = useState({
    startDate: firstDay,
    endDate: lastDay,
  });
  
  
  const [fromWarehouse, setFromWarehouse] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [shouldFetchData, setShouldFetchData] = useState(false);
  const [isPrintMode, setIsPrintMode] = useState(false);

  const warehousesUrl = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
  const { data: warehousesData, loading: warehousesLoading } = useFetch(warehousesUrl);

  const filterUrl = shouldFetchData
    ? `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/items/${currentTenantId}/${currentCompanyId}/${currentBranchId}/${fromWarehouse}/${formStates.startDate}/${formStates.endDate}`
    : null;
  const { data: filterDataResult, loading: filterLoading } = useFetch(filterUrl);

  useEffect(() => {
    if (warehousesData && warehousesData.data) {
      const formattedWarehouses = warehousesData.data.map(warehouse => ({
        _id: warehouse.id,
        label: warehouse.name_ar || warehouse.name,
        name_ar: warehouse.name_ar,
        name: warehouse.name,
      }));
      setWarehouses(formattedWarehouses);
    }
  }, [warehousesData]);

  const submitHandler = (e) => {
    e.preventDefault();
    setShouldFetchData(true);
  };

  useEffect(() => {
    if (filterDataResult?.data) {
      console.log('filterDataResult', filterDataResult.data);
    } else {
      console.log('No data received or data is null');
    }
  }, [filterDataResult]);

  const printHandler = () => {
    setIsPrintMode(true);
    setTimeout(() => {
      printableDiv(divPrintRef, currentLangId);
      setTimeout(() => {
        setIsPrintMode(false);
      }, 1000);
    }, 100);
  };

  const pdfHandler = () => {
    setIsPrintMode(true);
    setTimeout(() => {
      handleConvertToPDF({
        lang: 'ar',
        elementId: 'printableDiv',
        fileName: `تقرير_مستودع.pdf`
      });
      setTimeout(() => {
        setIsPrintMode(false);
      }, 1000);
    }, 100);
  };

  const exportExcel = () => {
    if (filterDataResult?.data && filterDataResult.data.length > 0) {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(filterDataResult.data);
      XLSX.utils.book_append_sheet(wb, ws, t("reports.Warehouse_Report"));
      XLSX.writeFile(wb, `${t("reports.Warehouse_Report")}.xlsx`);
    }
  };

   

  return (
    <div className='text-[#251658] h-[calc(100vh-50px)] custom-scrollbar'>
      <div id='header'>
        <p className='pb-3 text-sm'>{t("reports.Warehouse_Report")}</p>
      </div>
       
      <MwCardWrapper   >
        <form onSubmit={submitHandler} className='flex flex-col gap-5    p-5'>
          <div className="grid grid-cols-3 gap-5">
            <div className="w-full">
              <label className="block text-start text-[#251658] mb-2 text-xs">
                {t("reports.Date_From")} 
              </label>
              <div className="flex items-center">
                <MwInputText
                  inputType='date'
                  className="flex-grow"
                  value={formStates.startDate}
                  onChange={(e) => {
                    setFormStates({ ...formStates, startDate: e.target.value });
                    setShouldFetchData(false);
                  }}
                />
              </div>
            </div>

            <div className="w-full">
              <label className="block text-start text-[#251658] mb-2 text-xs">
                {t("reports.Date_To")} 
              </label>
              <div className="flex items-center">
                <MwInputText
                  inputType='date'
                  className="flex-grow"
                  value={formStates.endDate}
                  onChange={(e) => {
                    setFormStates({ ...formStates, endDate: e.target.value });
                    setShouldFetchData(false);
                  }}
                />
              </div>
            </div>

            <div className="w-full">
              <label className="block text-start text-[#251658] mb-2 text-xs">
                {t("reports.Choose_Warehouse")} 
              </label>
              <MwSelector
              withSearch={false}
              withLabel={false}
                label=""
                _data={warehouses}
                dataType="labelValue"
                initalValue={t("reports.Choose_Warehouse")}
                selectedItem={fromWarehouse 
                  ? warehouses.find(w => w._id === fromWarehouse) 
                  : null}
                setSelectedItem={(item) => {
                  setFromWarehouse(item._id);
                  setShouldFetchData(false);
                }}
                 className="w-full text-center"
                onClickNew={() => console.log('Add new warehouse')} // إضافة onClickNew
              />
            </div>
          </div>

          <div className='pt-3 flex justify-end'>
            {!filterLoading ? (
              <MwButton 
                type='saveBtn' 
                disabled={!formStates.startDate || !formStates.endDate || !fromWarehouse}
              >
                {t("reports.Prepare_Report")}
              </MwButton>
            ) : (
              <MwSpinnerButton/>
            )}
          </div>
        </form>
      </MwCardWrapper>

      {(shouldFetchData && filterLoading || filterDataResult) && (
        <MwCardWrapper id='Result'>
          {filterDataResult?.data ? (
            filterDataResult.data.length > 0 ? (
              <div className='w-full'>
                <div className='flex justify-between'>
                  <div className='px-2 text-[#251658]'></div>
                  <div className='p-3 text-[#251658]'>
                    <ul className='flex gap-1'>
                      <li 
                        style={{ cursor: "pointer" }} 
                        onClick={exportExcel} 
                        className='px-2 py-1 flex items-center gap-1 bg-white border border-gray-200 hover:border-[#251658] hover:font-bold'
                      >
                        <FaRegFileExcel /> 
                        <span className='text-sm text-[#251658]'>{t("reports.Export_Excel")}</span>
                      </li>
                      <li 
                        style={{ cursor: "pointer" }} 
                        onClick={pdfHandler} 
                        className='px-2 py-1 flex items-center gap-1 bg-white border border-gray-200 hover:border-[#251658] hover:font-bold'
                      >
                        <FaFilePdf />
                        <span className='text-sm text-[#251658]'>{t("reports.Save_as_PDF")}</span>
                      </li>
                      <li 
                        style={{ cursor: "pointer" }} 
                        onClick={printHandler} 
                        className='px-2 py-1 flex items-center gap-1 bg-white border border-gray-200 hover:border-[#251658] hover:font-bold'
                      > 
                        <FaPrint />
                        <span className='text-sm text-[#251658]'>{t("reports.Print")}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  id='printableDiv'
                  ref={divPrintRef}
                  className={`text-[#251658] ${isPrintMode ? "" : "h-[calc(100vh-100px)] overflow-y-scroll custom-scrollbar"}`}
                >
                  <div className='text-[#251658] text-center'>
                    <div className='font-bold'>{t("reports.Warehouse_Report_for_Period")}</div>
                    <div className='font-medium'>
                      <span>{t("reports.From")} {formStates.startDate}</span>
                      <span className="mx-2">{t("reports.To")} {formStates.endDate}</span>
                    </div>
                  </div>
                  {/* عرض قائمة التقارير */}
                  {filterDataResult.data && <SalesReportsList data={filterDataResult} />}
                </div>
              </div>
            ) : (
              <NoDataFound msg={t("reports.No_Results")} />
            )
          ) : (
            <NoDataFound msg={t("reports.No_Results")} />
          )}
        </MwCardWrapper>
      )}
    </div>
  );
};

export default SalesReports;
